import { isTourV2Item } from 'lib/checkout/checkoutUtils'
import { createSelector } from 'reselect'
import { addTotals } from 'checkout/lib/utils/payments/totals'
import getTourV2ExperienceItemsViews from 'checkout/selectors/view/itemViews/getTourV2ExperienceItemsViews'
export const cartIncludesTourV2 = (state: App.State) => state.checkout.cart.items.some(isTourV2Item)

export const getTourExperienceTotals = createSelector(
  (state: App.State) => getTourV2ExperienceItemsViews(state),
  (offerViewsWithStatus): App.WithDataStatus<App.Checkout.ItemViewTotals> => {
    const tourExperienceTotalView = offerViewsWithStatus.data.map<App.WithDataStatus<App.Checkout.ItemViewTotals>>(item =>
      ({ hasRequiredData: offerViewsWithStatus.hasRequiredData, data: item.totals }),
    )
    return {
      hasRequiredData: offerViewsWithStatus.hasRequiredData,
      data: addTotals(tourExperienceTotalView).data,
    }
  },
)
